import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const ShiftRowContainer = styled('li')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'block',
  paddingLeft: theme.spacing(2),
  '&:hover': {
    backgroundColor: theme.palette.background.secondaryHover,
  },
}));

export const ShiftRowContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
  height: '3.75rem',
}));

export const ShiftInfoContainer = styled('div')(({ isLast, theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  paddingRight: theme.spacing(2), // Matches paddingLeft of CustomListContainer container without cutting off buttom border
}));

export const ShiftInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const DateBox = styled(Box)(({ theme }) => ({
  minWidth: '50px',
  textAlign: 'center',
  padding: theme.spacing(1),
  borderRadius: '8px',
  backgroundColor: 'transparent',
  '&.is-today': {
    backgroundColor: theme.palette.background.secondarySelected,
  },
}));

export const DateText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&.is-today': {
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  '&.is-past': {
    color: theme.colors.gray,
  },
}));

export const DayHeadline = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: 0,
  whiteSpace: 'nowrap',
}));

export const DaySubtitle = styled(Typography)(({ theme, color }) => ({
  color: color || theme.palette.text.secondary,
  fontSize: '0.875rem',
  lineHeight: 1.43,
}));

export const StyledArrowIcon = styled(Box)(({ theme }) => ({
  fontSize: '17px',
  color: theme.colors.gray,
  display: 'flex',
  alignItems: 'center',
}));
